import PageHeader from '@Components/PageHeader';
import { ToastGuidGroupList } from '@Components/ToastGuidGroups';

export default function ToastGuidGroups() {
  return (
    <div>
      <PageHeader
        navList={[
          { name: 'Settings', href: '/settings' },
          { name: 'Toast GUID Groups', href: '/settings/toast-guid-groups' },
        ]}
        title="Toast GUID Groups"
      />
      <ToastGuidGroupList />
    </div>
  );
}
